import React from 'react';
import PropTypes from 'prop-types';

import { Tooltip, TooltipProps } from '@material-ui/core';
import { SvgIconProps } from '@material-ui/core/SvgIcon';
import { InfoOutlined } from '@material-ui/icons';

type TitlePlacementType =
    | 'right'
    | 'bottom-end'
    | 'bottom-start'
    | 'bottom'
    | 'left-end'
    | 'left-start'
    | 'left'
    | 'right-end'
    | 'right-start'
    | 'top-end'
    | 'top-start'
    | 'top'
    | undefined;

interface InfoIconTooltipProps {
    readonly TooltipProps?: Omit<TooltipProps, 'title'>;
    readonly IconProps: SvgIconProps;
    readonly title: string | JSX.Element; // 'title' is now a required prop and cannot be undefined
    readonly titlePlacement?: TitlePlacementType;
}

function InfoIconTooltip({
    TooltipProps,
    IconProps,
    title,
    titlePlacement,
    ...otherProps
}: InfoIconTooltipProps): JSX.Element {
    return (
        <Tooltip
            arrow
            placement={titlePlacement}
            title={title}
            {...TooltipProps}
            {...otherProps}>
            <InfoOutlined {...IconProps} />
        </Tooltip>
    );
}

// Define defaultProps
InfoIconTooltip.defaultProps = {
    TooltipProps: {},
    titlePlacement: 'right'
};

export default InfoIconTooltip;
